import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import CloseIcon from "@mui/icons-material/Close";
import currency from "currency.js";
import BDatePicker from "../../common/input/BDatePicker";

export default function SessionOptions(props) {
  const { value = [] } = props;

  const onChange = (mode, idx, data) => {
    const arr = [...value];

    if (mode === "add") {
      arr.push(data);
    } else if (mode === "edit") {
      arr[idx] = data;
    } else if (mode === "delete") {
      arr.splice(idx, 1);
    }
    props.onChange(arr);
  };

  return (
    <Box>
      <Box>
        <Grid container alignItems="center">
          <Grid item xs={9}>
            <Typography variant="h6">Sessions</Typography>
            <Typography variant="body2" color="textSecondary">
              Date, time, and price options customers can book
            </Typography>
          </Grid>
          <Grid item xs={3} align="right">
            <Entry mode="add" value="" onChange={(mode, data) => onChange(mode, 0, data)} />
          </Grid>
        </Grid>
      </Box>
      <Paper elevation={0}>
        <Box px={2} pt={4} pb={2}>
          {value.map((session, idx) => (
            <Row key={idx} idx={idx} session={session} onChange={onChange} />
          ))}
          {value.length === 0 && (
            <Box px={2} py={4} align="center">
              <Typography variant="subtitle1">Add Session</Typography>
              <Typography variant="body1" color="textSecondary">
                Click + to add one or more date/time options
              </Typography>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

function Row(props) {
  const { idx, session } = props;

  const onChange = (mode, data) => {
    props.onChange(mode, idx, data);
  };

  return (
    <Box mb={1}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={9}>
          <Typography variant="body1">
            {session.date}
            {session.time ? ` · ${session.time}` : ""}
          </Typography>
        </Grid>
        <Grid item xs={2} align="right">
          <Typography variant="body2">
            {currency(session.pricing?.amount || 0).format()}
          </Typography>
        </Grid>
        <Grid item xs={1} align="right">
          <Entry mode="edit" session={session} onChange={onChange} />
        </Grid>
      </Grid>
    </Box>
  );
}

function Entry(props) {
  const { session, mode } = props;

  const [open, setOpen] = useState(false);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [price, setPrice] = useState("");

  useEffect(() => {
    if (open) {
      setDate(session?.date || "");
      setTime(session?.time || "");
      setPrice(session?.pricing?.amount || "");
    } else {
      reset();
    }
  }, [open]);

  const reset = () => {
    setDate("");
    setTime("");
    setPrice("");
  };

  const submit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    props.onChange(mode, {
      date,
      time,
      pricing: { amount: currency(price).value },
    });
    setOpen(false);
    reset();
  };

  const handleDelete = () => {
    props.onChange("delete");
    setOpen(false);
    reset();
  };

  return (
    <span>
      <IconButton size="small" onClick={() => setOpen(true)}>
        {mode === "edit" ? <EditOutlinedIcon /> : <AddIcon />}
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
        <form onSubmit={submit}>
          <DialogTitle>
            {mode === "add" ? "Add Session" : "Edit Session"}
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box pt={2}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <BDatePicker
                    label="Date"
                    value={date}
                    onChange={(d) => setDate(d)}
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="time"
                    value={time}
                    label="Time"
                    name="time"
                    variant="outlined"
                    fullWidth
                    required
                    placeholder="e.g. Noon - 4pm"
                    onChange={(e) => setTime(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="price"
                    type="number"
                    value={price}
                    label="Price"
                    name="price"
                    variant="outlined"
                    fullWidth
                    required
                    onChange={(e) => setPrice(e.target.value)}
                    onWheel={(e) => {
                      e.target && e.target.blur();
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyOutlinedIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            {mode === "edit" && (
              <Button fullWidth onClick={handleDelete} style={{ color: "#e74c3c" }}>
                Remove
              </Button>
            )}
            <Button fullWidth variant="contained" color="primary" type="submit">
              Confirm
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </span>
  );
}
